<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-invoice" icon-small title="صورتحساب مشتریان" color="accent">

			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">صورتحساب جدید</v-tab>
					<v-tab :key="1">گزارش صورتحساب ها</v-tab>
					<v-tab :key="2">تسویه حساب ها</v-tab>

					<v-tabs-items v-model="activeTab" touchless class="mt-3">
						<v-tab-item :key="0">
							<v-slide-x-transition :hide-on-leave="true">
								<div v-if="step === 1">
									<v-row class="justify-center">
										<v-col cols="12" md="6">
											<v-form @submit.prevent="searchCustomer">
												<div class="mb-2 mt-4">
													ابتدا مشتری مورد نظر را جستجو کنید:
													<div><small class="grey--text">(جستجو میتواند بر اساس نام و نام
															خانوادگی، کدملی، شماره کارت، شماره موبایل باشد)</small>
													</div>
												</div>
												<v-text-field class="mb-4" ref="nationalCode" outlined v-model="searchPhrase" maxlength="50" label="اطلاعات مورد نظر را وارد کنید:" :error-messages="errorMessages" :rules="[() => !!searchPhrase || 'اطلاعات را وارد کنید']" required />
												<v-alert class="mb-2 mt-2" type="error" outlined v-if="searchMessage">{{
													searchMessage }}</v-alert>
												<v-btn color="primary" type="submit" :loading="searchLoading" block>
													جستجوی مشتری
												</v-btn>
											</v-form>
										</v-col>
									</v-row>
									<div v-if="members !== null" style="padding: 10px;border: 1px solid #ddd;border-radius: 10px;margin-top: 25px;">
										<div class="mb-2 pa-2 pr-0 secondary--text" style="border-bottom: 1px dashed #ddd;">لیست مشتریان یافت شده مطابق با
											اطلاعات وارد شده:</div>
										<v-alert v-if="!members.length" outlined type="warning">مشتری با مشخصات وارد شده
											یافت نشد.</v-alert>
										<v-row v-for="(member, index) in members" :key="index" style="border-bottom: 1px dashed #eee;">
											<v-col cols="12" sm="3">
												{{ member.fullName }}
												<div><small class="grey--text">کد ملی: {{ member.nationalCode }}</small>
												</div>
											</v-col>
											<v-col cols="12" sm="3">
												<div>اعتبار کیف پول:</div>
												<div class="grey--text">{{ member.credit.toString().toPriceFormat() }}
													تومان</div>
											</v-col>
											<v-col cols="12" sm="6">
												<div class="d-flex flex-wrap justify-center">
													<v-btn small outlined color="primary" class="mx-1 mb-1" @click="newFactor(member)">ثبت صورتحساب جدید</v-btn>
													<v-btn small outlined color="info" class="mx-1" @click="memberFactors(member)">لیست صورتحساب ها</v-btn>
												</div>
											</v-col>
										</v-row>
									</div>
								</div>
							</v-slide-x-transition>

							<v-slide-x-transition :hide-on-leave="true">
								<div v-if="step === 2 || step === 3">
									<v-row class="justify-center">
										<v-col cols="12" md="8">
											<v-form ref="formFactor">
												<v-card>
													<div>
														<v-btn text color="grey" small @click="returnToStep1">
															<v-icon x-small class="ml-1">mdi-arrow-right</v-icon>
															بازگشت
														</v-btn>
													</div>
													<v-img class="align-end text-white" height="150" contain :src="require('@/assets/online-payment.webp')">
													</v-img>

													<v-slide-x-transition :hide-on-leave="true">
														<div v-if="step === 3" class="px-3">
															<v-alert type="success" outlined>
																صورتحساب با موفقیت ثبت شد.
																<br />
																شماره سیستمی صورتحساب: {{ localData.code }}
																<div class="text-center py-3 d-flex flex-column justify-center align-center">
																	<v-btn v-if="showOnlinePaymentBtns" width="250" class="mb-3" color="info" outlined :loading="submitLoading" @click="submitOnlinePayment(0)">
																		<v-icon class="ml-1">mdi-credit-card</v-icon>
																		هدایت به درگاه پرداخت آنلاین
																	</v-btn>
																	<v-btn v-if="showOnlinePaymentBtns" width="250" class="mb-3" color="info" outlined :loading="submitLoading" @click="submitOnlinePayment(1)">
																		<v-icon class="ml-1">mdi-cellphone-message</v-icon>
																		ارسال پیامک لینک پرداخت ({{
																			localData.member.mobile }})
																	</v-btn>
																	<v-btn @click="print(localData)" color="info" outlined width="250">
																		<v-icon>mdi-printer</v-icon>
																		چاپ صورتحساب
																	</v-btn>
																	<v-btn class="mt-4" @click="step = 1" elevation="0" width="250">
																		<v-icon x-small class="ml-1">mdi-arrow-right</v-icon>
																		بازگشت</v-btn>
																</div>
															</v-alert>
														</div>
													</v-slide-x-transition>

													<div v-if="step === 2">
														<v-card-subtitle class="pt-4 text-center ">
															شما در حال ثبت صورتحساب برای شخص با مشخصات زیر می باشید:
															<v-card color="#eee" elevation="0" class="pa-2 my-2">
																<div class="secondary--text mb-2" style="font-size: 14pt;">{{
																	localData.member.fullName }}</div>
																<div class="grey--text">کد ملی:</div>
																<div class="secondary--text" style="font-size: 14pt;">{{
																	localData.member.nationalCode }}</div>
															</v-card>
														</v-card-subtitle>

														<v-card-text>
															<v-row>
																<v-col cols="12" class="pt-3 pb-8">
																	<div>
																		<div class="mb-1">
																			تاریخ صورتحساب:
																			<span class="secondary--text mr-1">{{ new
																				Date().toLocaleDateString('fa-IR').toString().toPersianDigits()
																			}}</span>
																		</div>
																		<!-- <date-picker ref="regDate2" v-model="localData.createAt" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable auto-submit :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']" />
																		<div class="red--text">
																			{{ datePickerValidatioin }}
																		</div> -->
																	</div>
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-field outlined class="align-center center-input" :disabled="true" v-model="localData.code" :label="localData.id === emptyId ? 'شماره سیستمی (شماره پس از ذخیره ایجاد می شود)' : 'شماره سیستمی'" :error-messages="errorMessages" />
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-field outlined class="align-center center-input" v-model="localData.userCode" label="شماره فرعی صورتحساب (اختیاری)" :error-messages="errorMessages" />
																</v-col>
																<v-col cols="12" class="py-0 d-flex justify-center">
																	<v-card color="#eee" class="py-3 my-3" style="width: 100%;" elevation="0">
																		<div class="text-center mb-2">اقلام صورتحساب
																		</div>
																		<v-divider></v-divider>
																		<div class="text-center mt-3" style="overflow-y: auto;">
																			<table style="width: 80%;margin: auto;min-width: 300px;">
																				<thead>
																					<tr>
																						<th style="width: 60%;border-bottom: 1px solid grey;">
																							شرح</th>
																						<th style="border-bottom: 1px solid grey;">
																							فی (تومان)</th>
																						<th style="border-bottom: 1px solid grey;">
																							تعداد</th>
																						<th style="border-bottom: 1px solid grey;">
																						</th>
																					</tr>
																				</thead>
																				<tbody>
																					<tr v-for="(item, index) in localData.agentFactorItems || []" :key="item.id + index">
																						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-field outlined dense class="right-input" v-model="item.product" label="شرح کالا/خدمات" :error-messages="errorMessages" :rules="[(val) => !!val || 'شرح کالا/خدمات را وارد کنید']" required /></td>
																						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-field outlined dense class="center-input" type="number" v-model="item.count" label="تعداد" :error-messages="errorMessages" :rules="[(val) => val > 0 || 'تعداد را به صورت صحیح وارد کنید']" required @input="updateAmount()" />
																						</td>
																						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-money outlined dense class="center-input" v-model="item.fee" label="فی" :error-messages="errorMessages" :rules="[(val) => localData.agentFactorItems[index].fee > 0 || 'فی را به صورت صحیح وارد کنید']" required @change="updateAmount()" />
																						</td>
																						<td style="border-bottom: 1px solid #ddd;">
																							<v-btn icon v-if="localData.id === emptyId"><v-icon small color="red" @click="removeFactorItem(index)">mdi-close</v-icon></v-btn>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																			<div class="text-center py-3 mb-3" v-if="localData.id === emptyId">
																				<v-btn small color="secondary" @click="addFactorItemRow()">افزودن
																					ردیف</v-btn>
																			</div>
																		</div>
																	</v-card>
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-money outlined class="align-center center-input" v-model="localData.amount" label="مبلغ صورتحساب (تومان)" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید', () => checkoutType != 2 || localData.amount <= localData.member.credit || 'مبلغ وارد شده از اعتبار کیف پول مشتری بیشتر است']" required />
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-textarea outlined class="" v-model="localData.description" label="شرح صورتحساب" :error-messages="errorMessages" :rules="[() => !!localData.description || 'شرح صورتحساب را وارد کنید']" required />
																</v-col>
																<v-col cols="12" class="py-0 d-flex">
																	<label class="ml-2">نحوه پرداخت:</label>
																	<v-radio-group class="pt-0 mt-0" v-model="checkoutType" column v-if="!alreadyPayed">
																		<div class="d-flex">
																			<v-radio class="small rtl" :disabled="localData.member.walletIsLock" label="برداشت از کیف پول" color="secondary" :value="2"></v-radio>
																			<v-chip class="" color="primary" small dense v-if="localData.member.walletIsLock">
																				<v-icon small left>mdi-lock</v-icon>
																				<small>کیف پول مشتری قفل است</small>
																			</v-chip>
																			<v-chip class="mr-1" color="#f5b8ff" small dense v-else>
																				<small class="secondary--text">موجودی:</small>
																				<span class="secondary--text mr-1" style="font-size: 12pt;">{{
																					localData.member.credit.toString().toPriceFormat()
																				}}</span>
																				<span class="secondary--text mr-1" style="font-size: 11pt;">تومان</span>
																			</v-chip>
																		</div>
																		<div class="d-flex" v-if="checkActivePart('agentFactorGateway')">
																			<v-radio class="small rtl" label="درگاه بانکی" color="secondary" :value="3"></v-radio>
																			<v-chip class="mr-1" color="#f5b8ff" small dense>
																				<small class="secondary--text">کارمزد:</small>
																				<span class="secondary--text mr-1" style="font-size: 12pt;">{{
																					commission.toString().toPriceFormat()
																				}}</span>
																				<span class="secondary--text mr-1" style="font-size: 11pt;">تومان</span>
																			</v-chip>
																		</div>
																	</v-radio-group>
																	<div v-else>
																		صورتحساب به روش {{ localData.checkoutType === 2
																			? 'کیف پول' : localData.checkoutType === 3 ?
																				'پرداخت آنلاین' : 'نامعلوم' }} پرداخت شده است
																		<gateway-details :data="localData.memberPurchase" v-if="localData.memberPurchase" />
																	</div>
																</v-col>
																<v-col cols="12" class="py-3" v-if="checkoutType === 2 && !alreadyPayed">
																	<v-card color="#eee" class="px-2 d-flex">
																		<v-text-field ref="mobile" :disabled="true" v-model="localData.member.mobile" maxlength="11" label="موبایل" />
																		<div class="d-flex px-2 align-center" style="width:170px">
																			<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید" />
																			<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال
																					کد</small></v-btn>
																			<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
																		</div>
																	</v-card>
																</v-col>
															</v-row>
														</v-card-text>

														<v-card-actions class="mb-12">
															<v-row class="justify-center">
																<v-col cols="12" md="9" class="d-flex flex-column">
																	<v-btn v-if="showOnlinePaymentBtns" block class="mb-3" color="primary" :loading="submitLoading" @click="submitOnlinePayment(0)">
																		<v-icon class="ml-1">mdi-credit-card</v-icon>
																		هدایت به درگاه پرداخت آنلاین
																	</v-btn>
																	<v-btn v-if="showOnlinePaymentBtns" block class="mb-3" color="primary" :loading="submitLoading" @click="submitOnlinePayment(1)">
																		<v-icon class="ml-1">mdi-cellphone-message</v-icon>
																		ارسال پیامک لینک پرداخت ({{
																			localData.member.mobile }})
																	</v-btn>
																	<v-btn v-if="localData.id === emptyId" block class="mb-3" color="primary" :loading="submitLoading" @click="submitFactor()">
																		ثبت صورتحساب
																	</v-btn>
																	<v-btn v-if="localData.id != emptyId" block class="mb-3" color="info" outlined @click="print(localData)">
																		<v-icon class="ml-1">mdi-printer</v-icon>
																		چاپ
																	</v-btn>
																	<v-btn block class="mb-3" @click="step = 1">بازگشت</v-btn>
																</v-col>
															</v-row>
														</v-card-actions>
													</div>
												</v-card>
											</v-form>
										</v-col>
									</v-row>
								</div>
							</v-slide-x-transition>
						</v-tab-item>
						<v-tab-item :key="1">
							<v-row class="mt-3" v-if="activeTab === 1">
								<v-col cols="12">
									<AgentFactors ref="agentFactors" @edit="edit" @remove="remove" userType='agent' :date-range="dateRange" />
								</v-col>
							</v-row>
						</v-tab-item>
						<v-tab-item :key="2">
							<v-row class="mt-3">
								<v-col cols="12">
									<AgentFactorCheckoutTransactions area="agent" :agentId="getCurrentUser.userData.id" />
								</v-col>
							</v-row>
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
			</div>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />

		<div id="printHtml" style="display: none;">
			<agent-factor-printHtml v-if="localData && printToggler" @ready="printReady = true" :id="localData.id" />
		</div>

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import printJS from 'print-js'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import AgentFactors from '@/components/forms/AgentFactors.vue'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'AgentFactorsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'agent-factor-printHtml': () => import('@/components/prints/AgentFactorPrintHtml'),
			'gateway-details': () => import('@/components/GatewayDetails'),
			Countdown: () => import('@/components/Countdown'),
			AgentFactorCheckoutTransactions: () => import('@/components/forms/AgentFactorCheckoutTransactions'),
			AgentFactors: AgentFactors
		},
		data() {
			return {
				members: null,
				sendCodeVisible: true,
				emptyId: emptyId,
				searchLoading: false,
				submitLoading: false,
				optLoading: false,
				searchMessage: '',
				step: 1,
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedMember: null,
				activeTab: 0,
				dateRange: { start: '', end: '' },
				searchPhrase: '',
				printReady: false,
				printToggler: false,
				printLoadingId: '',
				checkoutType: 0
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			...get('agentAppSettings', {
				agentSettings: 'settings'
			}),
			excelFileName() {
				let name = 'لیست صورتحساب های کیف پولی'
				name += '.xls'
				return name
			},
			commission() {
				if (this.localData.commission)
					return this.localData.commission
				if (!this.localData.amount)
					return 0

				let commission = this.getCurrentUser?.userData?.metaData?.useDefaultCommission === false ? this.getCurrentUser?.userData?.metaData.agentFactorCommission : this.agentSettings.agentFactorCommission
				let maxCommission = this.getCurrentUser?.userData?.metaData?.useDefaultCommission == false ? this.getCurrentUser?.userData?.metaData.maxAgentFactorCommission : this.agentSettings.maxAgentFactorCommission

				let calculatedCommission = this.localData.amount * commission / 100
				return Math.min(Math.round(calculatedCommission), maxCommission)
			},
			alreadyPayed() {
				return this.localData.id !== emptyId && (!!this.localData.memberPurchase || this.localData.checkoutType !== 3)
			},
			showOnlinePaymentBtns() {
				return this.localData.id !== emptyId && this.checkoutType === 3 && !this.alreadyPayed && this.checkActivePart('agentFactorGateway')
			}
		},
		mounted() {

		},
		methods: {
			sendOTP() {
				if (!this.localData.member.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendWalletWithdrawOTP', this.localData)
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			edit(item) {
				api.get(`agent/AgentFactor/Get/${item.id}`, null)
					.then(response => {
						this.localData = response
						this.checkoutType = this.localData.checkoutType
						this.activeTab = 0
						this.step = 2
					}).catch(err => {
						toast.error('خطا در دریافت اطلاعات صورتحساب از سرور')
					})
					.finally(() => {

					})
			},
			async remove(item) {
				toast.error('در حال حاضر امکان حذف صورتحساب وجود ندارد.')
				return
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/agent/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			searchCustomer() {
				this.searchMessage = ''
				if (!this.searchPhrase) {
					this.searchMessage = 'ابتدا عبارت مورد نظر جهت جستجو را وارد کنید'
					return
				}
				this.searchLoading = true
				api.get('agent/customer/GetForFactor/' + this.searchPhrase, null)
					.then(
						response => {
							this.members = response
						})
					.catch(err => {
						this.searchMessage = err.message
					})
					.finally(() => this.searchLoading = false)
			},
			async submitFactor() {
				if (!this.$refs.formFactor.validate()) {
					toast.error('لطفا ابتدا تمام موارد فرم را تکمیل نمایید.')
					return
				}
				if (!this.checkoutType) {
					toast.error('نحوه پرداخت صورتحساب مشخص نشده است.')
					return
				}
				if (this.checkoutType === 2 && !this.localData.mobileOtp) {
					toast.error('کد تائیدیه پیامکی وارد نشده است.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ثبت این صورتحساب مطمئن هستید؟',
				)) {
					this.submitLoading = true
					let data = cloneDeep(this.localData)
					data.checkoutType = this.checkoutType
					api.post('agent/AgentFactor/Create', data)
						.then(
							response => {
								toast.success('صورتحساب با موفقیت ذخیره شد.')
								this.localData = response
								this.step = 3
								// this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.submitLoading = false
						})
				}
			},
			newFactor(member) {
				this.localData = {
					id: emptyId,
					member: member,
					amount: 0,
					agent: this.getCurrentUser.userData,
					createAt: new Date().toJSON(),
					agentFactorItems: [{ id: emptyId, product: '', count: 1, fee: 0 }]
				}
				this.step = 2
			},
			memberFactors(member) {
				this.activeTab = 1
				setTimeout(() => {
					this.$refs.agentFactors.setMember(member)
					this.$refs.agentFactors.setDateRange({ start: '', end: '' })
					this.$refs.agentFactors.loadData()
				}, 300)
			},
			returnToStep1() {
				if (this.step === 3)
					this.searchCustomer()
				this.step = 1
			},
			print(data) {
				this.printReady = false
				this.printLoadingId = data.id
				this.printToggler = false
				setTimeout(() => {
					this.localData = data
					let timer = 0
					this.printToggler = true
					let interval = setInterval(() => {
						timer++
						if (timer > 300 || this.printReady) {
							clearInterval(interval)
							this.printLoadingId = ''
						}
						if (this.printReady)
							printJS({
								printable: 'printHtml',
								type: 'html',
								scanStyles: false, // If true inline styles will be removed
								targetStyles: ['*'],
								style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
							})
						setTimeout(() => {
							this.printToggler = false
						}, 3000)
					}, 100)
				}, 100)
			},
			submitOnlinePayment(type) {
				this.submitLoading = true
				this.localData.agentFactorOnlinePaymentMethod = type
				this.localData.commission = this.commission
				api.post('agent/AgentFactor/OnlinePayment', this.localData)
					.then(response => {
						if (type === 1)
							toast.success('پیامک با موفقیت ارسال شد.')
						else if (type === 0) {
							if (response.gateway === 'sep') {
								let form = document.getElementById('sepForm')
								let sepToken = document.getElementById('sepToken')
								sepToken.value = response.token
								form.submit()
							}
							else if (response.gateway === 'sepehr') {
								let form = document.getElementById('sepehrForm')
								let sepehrToken = document.getElementById('sepehrToken')
								sepehrToken.value = response.token
								let sepehrTerminal = document.getElementById('sepehrTerminalId')
								sepehrTerminal.value = response.terminalId
								form.submit()
							}
							else {
								window.location.replace(response.gatewayUrl)
							}
						}
					})
					.catch(err => {
						this.submitLoading = false
						toast.error(err.message)
					})
					.finally(x => {
						this.submitLoading = false
					})
			},
			addFactorItemRow() {
				if (!this.localData.agentFactorItems)
					this.localData.agentFactorItems = []
				this.localData.agentFactorItems.push({ id: emptyId, product: '', count: 1, fee: 0 })
			},
			removeFactorItem(index) {
				this.localData.agentFactorItems.splice(index, 1)
				this.updateAmount()
			},
			updateAmount() {
				this.localData.amount = (this.localData.agentFactorItems || []).reduce((sum, item) => sum + (Number(item.count || 0) * Number(item.fee || 0)), 0)
			}

		},
	}
</script>
<style></style>